import { formatPercent } from "./formatPercent";

// Сдвиг против ошибки плавающей точки: 0.29 * 100 = 28.999999999999996.
const EPSILON = 1e-9;

// Доля сильных игроков с предметом — вниз до целого процента: предмет чуть ниже порога
// ключевого (74,7 % при пороге 75 %) не должен выглядеть как ключевой. Меньше 1 % — «<1 %»,
// а не «0 %», который читается как «не берут совсем». Все доли предметов на экране разбора —
// через неё, чтобы один предмет везде показывал одно число.
export const formatPickRate = (share: number, locale: string): string => {
  if (share > 0 && share < 0.01) {
    return `<${formatPercent(0.01, locale)}`;
  }
  return formatPercent(Math.floor(share * 100 + EPSILON) / 100, locale);
};
